import * as React from 'react'
import Box from '@mui/system/Box'
import TextField from '@mui/material/TextField'
import { useTranslation } from 'react-i18next'

type VendorWizardUserBasicInfoFormProps = {
  values: {
    firstname: string | null
    lastname: string | null
    phone: string | null
    email: string | null
  }
  errors: {
    firstname: string
    lastname: string
  }
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void
}

const VendorWizardUserBasicInfoForm: React.FC<VendorWizardUserBasicInfoFormProps> = ({
  values,
  errors,
  onChange,
  onBlur
}) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gridGap: 16 }}>
      <TextField
        name="firstname"
        label={t('first-name')}
        onChange={onChange}
        value={values.firstname || ''}
        onBlur={onBlur}
        required
        variant="filled"
        fullWidth
        helperText={errors.firstname}
        error={errors.firstname !== ''}
      />
      <TextField
        name="lastname"
        label={t('last-name')}
        onChange={onChange}
        value={values.lastname || ''}
        onBlur={onBlur}
        required
        variant="filled"
        fullWidth
        helperText={errors.lastname}
        error={errors.lastname !== ''}
      />
      <TextField
        name="phone"
        label={t('phone')}
        variant="filled"
        onChange={onChange}
        value={values.phone || ''}
        sx={{ width: { xs: '100%', sm: 180 } }}
        type="tel"
      />
      <div />
      <TextField name="email" label={t('email')} value={values.email || ''} variant="filled" disabled fullWidth />
    </Box>
  )
}

export default VendorWizardUserBasicInfoForm
